import { FC, memo, useMemo } from 'react';

import { useCMSGameCovers } from '../../../hooks';
import { GameV1 } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { getGameCover } from '@/helpers/cdn';
import { PlayButton } from '@/modules/game/components/PlayButton';

import { ScSmallGameCardBack, ScSmallGameCardInner } from './styled';

interface ISmallGameCardProps {
  game: GameV1;
  onPlayClick?: () => void;
}

export const SmallGameCard: FC<ISmallGameCardProps> = memo(({ game }) => {
  const { id, fullPath } = game;
  const { covers } = useCMSGameCovers();

  const url = useMemo(() => {
    return covers?.[id]?.cover?.url || getGameCover(id);
  }, [covers, id]);

  return (
    <ScSmallGameCardInner>
      <ImageComponent
        alt="cover"
        className="cover-image"
        src={url}
        loading="lazy"
        fill
      />
      <ScSmallGameCardBack>
        <PlayButton href={`/game/${fullPath}`} size={48} />
      </ScSmallGameCardBack>
    </ScSmallGameCardInner>
  );
});
